
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../../grpc"

import {
    Timestamp,
} from "../../../google/protobuf/timestamp"

import {
    Empty,
} from "../../../google/protobuf/empty"

export interface Institution {
    id: number /* 机构ID */
    name: string /* 机构名称 */
    description: string /* 机构描述信息 */
    logo?: string /* 机构logo */
}

export interface GetInstitutionRequest {
    institutionId?: number
}

export interface UpdateInstitutionRequest {
    id: number
    name?: string /* 机构名称 */
    description?: string /* 机构描述信息 */
    logo?: string /* 机构logo */
}

export interface CreateInstitutionRequest {
    name: string /* 机构名称 */
    description?: string /* 机构描述信息 */
    logo?: string /* 机构logo */
}

export interface CreateInstitutionResponse {
    id: number
    name: string /* 机构名称 */
    description?: string /* 机构描述信息 */
    logo?: string /* 机构logo */
}

export interface DeleteInstitutionRequest {
    id: number
}

export interface ListInstitutionsRequest {
    pageNum: number
    pageSize: number
}

export interface ListInstitutionsResponse {
    institutions: Array<Institution>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    pageElements: number
    pageNum: number
    pageSize: number
}

export interface ListMyInstitutionsRequest {
}

export interface ListMyInstitutionsResponse {
    institutions: Array<Institution>
}

export interface SetLoadingAnimationRequest {
    institutionId: number /* 机构ID */
    resourceKey: string /* 资源key */
    resourceType: string /* 资源类型 gif/video */
}

export interface LoadingAnimation {
    id: number
    createdAt: Timestamp
    resourceUrl: string
    resourceType: string
}

export interface GetLoadingAnimationRequest {
    institutionId: number /* 机构ID */
}

export interface UpdateAdvertisementBoardRequest {
    institutionId: number
    idleMinute: number /* 闲置时间 */
}

export interface AdvertisementBoard {
    institutionId: number
    idleMinute: number /* 闲置时间 */
    advertisements: Array<Advertisement>
}

export interface Advertisement {
    id: number
    createdAt: Timestamp
    resourceUrl: string
    resourceType: string
    enabled: boolean /* 是否启用 */
}

export interface CreateAdvertisementRequest {
    institutionId: number /* 机构ID */
    resourceKey: string /* 资源key */
    resourceType: string /* 资源类型 image/video */
}

export interface UpdateAdvertisementRequest {
    id: number
    resourceKey?: string /* 资源key */
    resourceType?: string /* 资源类型 image/video */
    enabled?: boolean /* 是否启用 */
}

export interface DeleteAdvertisementRequest {
    id: number
}

export interface GetAdvertisementBoardRequest {
    institutionId: number /* 机构ID */
}

export class InstitutionService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* 创建机构 */
    async createInstitution(request: CreateInstitutionRequest): Promise<Institution> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/CreateInstitution"
        return await this.call(method, path, request) as Institution
    }
    
    /* 删除机构 */
    async deleteInstitution(request: DeleteInstitutionRequest): Promise<Empty> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/DeleteInstitution"
        return await this.call(method, path, request) as Empty
    }
    
    /* 获取机构信息 */
    async getInstitution(request: GetInstitutionRequest): Promise<Institution> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/GetInstitution"
        return await this.call(method, path, request) as Institution
    }
    
    /* 更新机构信息 */
    async updateInstitution(request: UpdateInstitutionRequest): Promise<Institution> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/UpdateInstitution"
        return await this.call(method, path, request) as Institution
    }
    
    /* 获取机构信息列表 */
    async listInstitutions(request: ListInstitutionsRequest): Promise<ListInstitutionsResponse> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/ListInstitutions"
        return await this.call(method, path, request) as ListInstitutionsResponse
    }
    
    /* 获取自己的机构列表 */
    async listMyInstitutions(request: ListMyInstitutionsRequest): Promise<ListMyInstitutionsResponse> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/ListMyInstitutions"
        return await this.call(method, path, request) as ListMyInstitutionsResponse
    }
    
    /* 设置检测加载动画 */
    async setLoadingAnimation(request: SetLoadingAnimationRequest): Promise<LoadingAnimation> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/SetLoadingAnimation"
        return await this.call(method, path, request) as LoadingAnimation
    }
    
    /* 获取检测加载动画 */
    async getLoadingAnimation(request: GetLoadingAnimationRequest): Promise<LoadingAnimation> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/GetLoadingAnimation"
        return await this.call(method, path, request) as LoadingAnimation
    }
    
    async updateAdvertisementBoard(request: UpdateAdvertisementBoardRequest): Promise<AdvertisementBoard> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/UpdateAdvertisementBoard"
        return await this.call(method, path, request) as AdvertisementBoard
    }
    
    async getAdvertisementBoard(request: GetAdvertisementBoardRequest): Promise<AdvertisementBoard> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/GetAdvertisementBoard"
        return await this.call(method, path, request) as AdvertisementBoard
    }
    
    /* 新增广告 */
    async createAdvertisement(request: CreateAdvertisementRequest): Promise<Advertisement> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/CreateAdvertisement"
        return await this.call(method, path, request) as Advertisement
    }
    
    /* 更新广告 */
    async updateAdvertisement(request: UpdateAdvertisementRequest): Promise<Advertisement> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/UpdateAdvertisement"
        return await this.call(method, path, request) as Advertisement
    }
    
    /* 删除广告 */
    async deleteAdvertisement(request: DeleteAdvertisementRequest): Promise<Empty> {
        const method = "post"
        const path = "/scanner.v2.InstitutionService/DeleteAdvertisement"
        return await this.call(method, path, request) as Empty
    }
    
}
